import request from "@/services/request";
import moment from "moment";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { Message } from "element-ui";

// 不合格的船管理
// 新增不合格的船
export function addUnqualifiedShips(data) {
  return request({
    url: "/jput/ships",
    method: "post",
    data,
  });
}
// 修改不合格的船
export function editUnqualifiedShips(data) {
  return request({
    url: "/jput/ships",
    method: "put",
    data,
  });
}
// 获取不合格的船列表
export function getUnqualifiedShips(data) {
  return request({
    url: "/jput/ships/list",
    method: "get",
    data,
  });
}
// 删除不合格的船
export function deleteUnqualifiedShips(ids) {
  return request({
    url: "/jput/ships/" + ids,
    method: "delete",
  });
}
// 码头管理
// 列表
export function getTankList(params) {
  return request({
    url: "/jput/berth/list",
    method: "get",
    params,
  });
}
// 码头使用情况
export function getUseBerth(cancelToken) {
  return request({
    url: "/jput/berth/getUseBerth",
    cancelToken
  });
}
// 已存在的公司列表
export function getCompanyList() {
  return request({
    url: "/jput/nomination/getCustomerCompany",
  });
}
//新增
export function addTank(data) {
  return request({
    url: "/jput/berth",
    method: "post",
    data,
  });
}
// 修改
export function editTank(data) {
  return request({
    url: "/jput/berth",
    method: "put",
    data,
  });
}
export function deleteTank(ids) {
  return request({
    url: "/jput/berth/" + ids,
    method: "delete",
  });
}
export function detailTank(id) {
  return request({
    url: "/jput/berth/" + id,
    method: "get",
  });
}
// uploadFile
export function uploadFile(file) {
  const formdata = new FormData();
  formdata.append("file", file);
  return request({
    url: "/common/upload",
    method: "post",
    data: formdata,
  });
}
// 不合格的船管理
// 新增不合格的船
export function getUnqualifiedShipsList(params) {
  return request({
    url: "/jput/ships/list",
    method: "get",
    params,
  });
}
// 修改不合格的船
export function editUnqualifiedShipsList(data) {
  return request({
    url: "/jput/ships/list",
    method: "put",
    data,
  });
}
// 删除不合格的船
export function deleteUnqualifiedShipsList(ids) {
  return request({
    url: "/jput/ships/" + ids,
    method: "delete",
  });
}
// 储罐管理
// 添加油罐
export function addTanks(data) {
  return request({
    url: "/jput/tank",
    method: "post",
    data,
  });
}
// 修改油罐
export function editTanks(data) {
  return request({
    url: "/jput/tank",
    method: "put",
    data,
  });
}
// 油罐列表
export function getTanksList(params) {
  return request({
    url: "/jput/tank/list",
    params,
  });
}
// 上传文件
export function singleleUploadFile(file) {
  let formdata = new FormData();
  formdata.append("file", file);
  return request({
    url: "/common/upload",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    method: "post",
    data: formdata,
  });
}
//储罐新增附件
export function tanksAddFiles(data) {
  return request({
    url: "/jput/file",
    method: "post",
    data,
  });
}
// 全部公司列表
export function allCompanyList(params) {
  return request({
    url: "/jput/company/companyList",
    method: "get",
    params,
  });
}
// 储罐与公司关联
export function companyLink(data) {
  return request({
    url: "/jput/company",
    method: "post",
    data,
  });
}
// 驳船附件
// link 新增驳船附件
export function addBoatLink(data) {
  return request({
    url: "/jput/link",
    method: "post",
    data,
  });
}
// 驳船附件列表
export function boatListFile(params) {
  return request({
    url: "/jput/link/list",
    method: "get",
    params,
  });
}
// 删除驳船附件
export function deleteBoatFile(ids) {
  return request({
    url: "/jput/link/" + ids,
    method: "delete",
  });
}
// 储罐列表
export function getCQList(id) {
  return request({
    url: "/jput/file/getCQList/" + id,
  });
}
// COQ列表
export function getCoqList(params) {
  return request({
    url: "/jput/quantity/list",
    params,
  });
}
// BL列表
export function getBlList(params) {
  return request({
    url: "/jput/billOfLading/list",
    params,
  });
}
// barge签名
export function bargeSign(data) {
  return request({
    url: "/jput/nomination/bargeSign",
    method: "post",
    data,
  });
}
// jupt签名
export function juptSign(data) {
  return request({
    url: "/jput/nomination/jputSign",
    method: "post",
    data,
  });
}
// 驳船首页数据
export function getBoadDashboardList() {
  return request({
    url: "/jput/nomination/dashboard",
  });
}
//coq list
export function getCoqMangeListList(params) {
  return request({
    url: "/jput/quantity/list",
    params,
  });
}
export function getBillOfLadingList(params) {
  return request({
    url: "/jput/billOfLading/list",
    params,
  });
}
// 测量公司的tank
export function getMyCompanyTank(params) {
  return request({
    url: "/jput/tank/getMyCompanyTank",
    params,
  });
}
// barge获取Stamp
export function getBargeStamp(data) {
  return request({
    url: "/jput/nomination/getBargeStamp",
    method: "post",
    data,
  });
}
// 签名图片上传
export function uploadEsignature(data) {
  return request({
    url: "/jput/nomination/uploadESignature",
    method: "post",
    data,
  });
}
// 重置码头分配
export function resetBerth(params) {
  return request({
    url: "/jput/nomination/resetBerth",
    method: "get",
    params,
  });
}
// reset berth add reason
export function resetBerthReason(data) {
  return request({
    url: "/jput/nomination/resetBerth",
    method: "post",
    data,
  });
}
// complete barging normination
export function completeBargingNormination(id) {
  return request({
    url: `/jput/nomination/${id}/complete`,
    method: "put",
  });
}
// juput reset
export function juptResetSign(data) {
  return request({
    url: "/jput/nomination/jputResetSign",
    method: "post",
    data,
  });
}
// getBerth
export function getBerth() {
  return request({
    url: "/jput/berth/getBerth",
  });
}
export function getRequestNum() {
  return request({
    url: "/jput/request/selectRequestNum",
  });
}
// getSurveyo options
export function getSurveyoOptions() {
  return request({
    url: "/system/user/getSurveyor",
  });
}
// get audiolog list
export function getAuditLogList(params) {
  return request({
    url: "/jput/log/list",
    method: "get",
    params,
  });
}
// 查询barge是否合适
export function searchBargeBer(data) {
  return request({
    url: "/jput/berth/dockAllBer",
    method: "post",
    data
  })
}
// get barge list
export function getBargeList() {
  return request({
    url: "/system/user/getBargesWithoutBargeOperator",
  });
}

// attach barge
export function attachBarge(data) {
  return request({
    url: `/system/user/attachBarge`,
    method: "put",
    data
  });
}

// detach barge
export function detachBarge(data) {
  return request({
    url: `/system/user/detachBarge`,
    method: "put",
    data
  });
}

export function getAttachedBargeList() {
  return request({
    url: "/system/user/getUserList",
  });
}

export function getNominationExcelList(params) {
  return request({
    url: "/jput/nomination/excel/list",
    method: "get",
    params,
  });
}

export function exportNominationExcelList(params) {
  const filename = "download-excel-" + moment().format("yyyyMMDD") + ".xls"
  return request({
    url: "/jput/nomination/excel/export",
    method: "get",
    responseType: 'arraybuffer',
    params,
  }).then(data => {
    downloadFile(data, filename)
  }).catch(() => Message({ message: 'Export excel failed', type: "error", duration: 15000, showClose: true }))
}

export function getPilotExcelList(params) {
  return request({
    url: "/jput/nomination/pilot/excel/list",
    method: "get",
    params,
  });
}

export function exportPilotExcelList(params) {
  const filename = "download-excel-" + moment().format("yyyyMMDD") + ".xls"
  return request({
    url: "/jput/nomination/pilot/excel/export",
    method: "get",
    responseType: 'arraybuffer',
    params,
  }).then(data => {
    downloadFile(data, filename)
  }).catch(() => Message({ message: 'Export excel failed', type: "error", duration: 15000, showClose: true }))
}

export function addToNominationExcelList(data) {
  return request({
    url: "/loaded/save",
    method: "post",
    data,
  });
}

export function downloadFile(arrayBuffer, filename) {
  filename = filename ?? 'Download.txt'
  const url = window.URL.createObjectURL(new Blob([arrayBuffer]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export function getMooringExcelList(params) {
  return request({
    url: "/jput/nomination/mooringReport/excel/list",
    method: "get",
    params,
  });
}

export function exportMooringExcelList(params) {
  const filename = "download-excel-" + moment().format("yyyyMMDD") + ".xls"
  return request({
    url: "/jput/nomination/mooringReport/excel/export",
    method: "get",
    responseType: 'arraybuffer',
    params,
  }).then(data => {
    downloadFile(data, filename)
  }).catch(() => Message({ message: 'Export excel failed', type: "error", duration: 15000, showClose: true }))
}

export function getCompletedCoqList(params) {
  return request({
    url: "/jput/link/completed-nomination-links",
    method: "get",
    params,
  });
}

export function removeLogisticsExcelCallibrationRecord(id) {
  return request({
    url: "/loaded/delete/" + id,
    method: "delete",
  });
}

export function getBargeContactNumberList(params) {
  return request({
    url: "/bargeContactNumber/contact",
    method: "get",
    params,
  });
}

export function getJettyJlHoseOptions(params) {
  return request({
    url: "/jettyHose/getData",
    method: "get",
    params,
  });
}

export function getBillingRecordQuantity(params) {
  return request({
    url: "/billingHistory/billingHistoryQuantity",
    method: "get",
    params,
  });
}

export function getAllBillingRecord(params) {
  return request({
    url: "/jput/nomination/billingRecord",
    method: "get",
    params,
  });
}

export function getHistoryBillingRecord(params) {
  return request({
    url: "/billingHistory/list",
    method: "get",
    params,
  });
}

export function exportBillingRecordExcel(params) {
  const filename = "billing-record-excel-" + moment().format("yyyyMMDD") + ".xls"
  return request({
    url: "/jput/nomination/billingRecord/excel/export",
    method: "get",
    responseType: 'arraybuffer',
    params,
  }).then(data => {
    downloadFile(data, filename)
  }).catch(() => Message({ message: 'Export excel failed', type: "error", duration: 15000, showClose: true }))
}

export function sendBillingScheduledEmailByDate(data) {
  return request({
    url: `/billingHistory/sendScheduledEmailByDate?startDate=${data.startDate}&endDate=${data.endDate}`,
    method: "post",
    responseType: "blob",
  });
}

export function getShipVettingListCount() {
  return request({
    url: "/shipVetting/getRequestCountsByStatus",
    method: "get",
  });
}

export function getShipVettingList(params) {
  return request({
    url: "/shipVetting/getLatestRequest",
    method: "get",
    params,
  });
}

export function addNewShipVettingRequest(sysRequestDTO, files) {
  const formData = new FormData();
  formData.append("sysRequestDTO", JSON.stringify(sysRequestDTO));
  if (files.length > 0) {
    files.forEach((file) => {
      formData.append("files", file);
    });
  } else {
    formData.append("files", null);
  }
  return request({
    url: "/shipVetting/insertWithDocuments",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getShipVettingRequestData(params) {
  return request({
    url: "/shipVetting/getVettingData/" + params,
    method: "get",
  });
}

export function updateShipVettingRequestStatus(id, data) {
  return request({
    url: "/shipVetting/updateStatus/" + id,
    method: "put",
    data,
  });
}

export function updateShipVettingRequestData(id, data) {
  return request({
    url: "/shipVetting/modifyRequest/" + id,
    method: "put",
    data
  });
}

export function uploadShipVettingShipDocument(id, files, deleteIds) {
  const formData = new FormData();
  // formData.append("deletedIds", deleteIds)
  if (deleteIds.length > 0) {
    const numbersString = `[${deleteIds.join(",")}]`;
    formData.append("deletedIds", numbersString)
  }

  if (files.length > 0) {
    files.forEach((file) => {
      formData.append("files", file);
    });
  } else {
    formData.append("files", null);

  }

  return request({
    url: "/shipVetting/uploadCustomerDocuments/" + id,
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function updateShipVettingInspection(id, data, shipStatus) {
  const formData = new FormData();
  if (!data.id || data.id == null) {
    formData.append("inspectionId", null);
  } else {
    formData.append("inspectionId", data.id);
  }
  formData.append("inspectionDate", data.inspectionDate);
  formData.append("inspectionRemarks", data.inspectionRemarks || "");
  if (data.documents.length > 0) {
    data.documents.forEach((file) => {
      formData.append("files", file);
    });
  } else {
    formData.append("files", null);
  }
  if (data.deletedIds.length > 0) {
    const numbersString = `[${data.deletedIds.join(",")}]`;
    formData.append("deletedIds", numbersString)
  } else {
    formData.append("deletedIds", "")
  }
  if(shipStatus) {
    formData.append("shipStatus", shipStatus);
  }
  return request({
    url: "/shipVetting/uploadInspectorDocuments/" + id,
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getShipVettingHistory(params) {
  return request({
    url: "/shipVetting/getAllRequestsByImo",
    method: "get",
    params,
  });
}

export function getShipVettingHistoryTimeline(id, pageNum, pageSize) {
  pageNum = pageNum ?? 1
  pageSize = pageSize ?? 20
  return request({
    url: "/shipVettingLog/" + id,
    params: {
      pageNum,
      pageSize
    },
    method: "get",
  });
}

export function deleteShipVettingRequest(id) {
  return request({
    url: "/shipVetting/delete/" + id,
    method: "delete",
  });
}

export function getSystemLog(params) {
  return request({
    url: "/jput/accessLog/list",
    method: "get",
    params,
  });
}

export function getSdsFileByNomId(nomId) {
  return request({
    url: `/jput/nomination/sdsFile/${nomId}`,
    method: 'get',
  });
}

export function getUnseenDisclaimers() {
  return request({
    url: '/disclaimer/unseen',
    method: 'get'
  });
}

export function updateDisclaimerSeen(id) {
  return request({
    url: `/disclaimer/updateSeen/${id}`,
    method: 'put'
  });
}

export function modifyLogisticsRequest(id, data) {
  return request({
    url: `/shipVetting/logistics/modifyRequest/${id}`,
    method: 'put',
    data
  });
}

export function getAgentOptions() {
  return request({
    url: "/system/user/getAgentAdminList",
  });
}


export function uploadOtherFile(formData) {
  return request({
    url: "/jput/link/uploadOtherFile",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function jputSignVessel(data) {
  return request({
    url: "/jput/nomination/jputSignVessel",
    method: "post",
    data,
  });
}

export function jputResetSignVessel(data) {
  return request({
    url: "/jput/nomination/jputResetSignByOperation",
    method: "post",
    data,
  });
}

export function getCQVesselList(id) {
  return request({
    url: "/jput/file/getCQList/vessel/" + id,
  });
}

export function createCustomerVetReq(formData) {
  return request({
    url: `/customerVetting/create`,
    method: 'post',
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getShipVettingHistoryByImo(imoNo) {
  return request({
    url: `/shipVetting/searchByImo`,
    method: 'get',
    params: {
      imo: imoNo
    }
  });
}

export function getShipVettingListAll(params) {
  return request({
    url: `/customerVetting/list`,
    method: 'get',
    params
  });
}

export function getCreateDateList(params) {
  return request({
    url: `/customerVetting/getHistoryCreateDateList`,
    method: 'get',
    params
  });
}

export function getCustomerVettingInfo(id) {
  return request({
    url: `/customerVetting/getInfo/${id}`,
    method: 'get',
  });
}

export function updateCustomerDoc(id, files, deleteIds) {
  const formData = new FormData();
  // formData.append("deletedIds", deleteIds)
  if (deleteIds.length > 0) {
    const numbersString = `${deleteIds.join(",")}`;
    formData.append("deletedIds", numbersString)
  }

  if (files.length > 0) {
    files.forEach((file) => {
      formData.append("files", file);
    });
  } else {
    formData.append("files", null);

  }
  return request({
    url: `/customerVetting/updateDocs/${id}`,
    method: 'post',
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getCompanyListByImo(imo) {
  return request({
    url: `/customerVetting/listByImo/${imo}`,
    method: 'get',
  });
}

export function getCustomerVettingRecord(id) {
  return request({
    url: `/customerVetting/previousRecords/${id}`,
    method: 'get',
  });
}

export function getShipVettingLog(id) {
  return request({
    url: `/customerVetting/logs/${id}`,
    method: 'get',
  });s
} 

export function getCustomerReqCount() {
  return request({
    url: `/customerVetting/getRequestCountsByStatus`,
    method: 'get',
  });
}

export function updateCustomerVettingStatus(data){
  return request({
    url: `/customerVetting/updateStatus`,
    method: 'post',
    data
  });
}

export function updateShipInfo(id, data) {
  return request({
    url: `/customerVetting/modify/${id}`,
    method: 'put',
    data
  });
}

export function deleteCustomerVetting(id) {
  return request({
    url: `/customerVetting/delete/${id}`,
    method: 'delete',
  });
}